module.exports = __webpack_public_path__ + "static/media/Cisco.e5eae4ae.png";